import React, { useEffect, useState } from "react";
import Api from "../api/Api";
import AdvancedList from "../controls/AdvancedList";
import SortButton from "../controls/SortButton";
import Page from "../layout/Page";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default function CardList() {

	let navigate = useNavigate();
	const [cards, setCards] = useState(null);
	const [departments, setDepartments] = useState(null);

	useEffect(() => {
		Api.put('cards/getcards', null, response => {
			setCards(response.data.cards);
			setDepartments(response.data.departments);
		});
	}, []);

	const types = {
		1: t.cardTypeVendor,
		2: t.cardTypeCustomer,
		3: t.cardTypeEmployee,
	}

	const renderHeader =
		<tr>
			<th width="140">{t.cardType}</th>
			<th width="100">{t.cardIdNumber}</th>
			<th>{t.cardName}</th>
			<th>{t.cardDepartment}</th>
			<th>{t.cardRequestApproved}</th>
			<th width="150">{t.commonState}</th>
		</tr>

	const renderCells = (card) => [
		types[card.type],
		card.idNumber,
		card.name,
		departments[card.departmentID].name,
		t.formatDatetime(card.lastCreated),
		card.state == 1 ? t.commonActive : t.commonInactive
	]

	return (
		<Page title="cardList">
			<AdvancedList
				data={cards}
				header={renderHeader}
				renderCells={renderCells}
				onRowClick={(card) => navigate(`/cards/${card.id}`)}
				searchProperties={["idNumber", "name"]}
				name="cards"
			/>
		</Page>
	);
}